import React, { useState, useEffect } from 'react';
import Modal from '../ui/Modal';
import GlassButton from '../ui/Button';
import InputField from '../ui/InputField';
import CustomSelect from '../ui/Select'; // Usando o Select customizado
import useData from '../../hooks/useData';

const ToolFormModal = ({ isOpen, onClose, onSave, toolToEdit }) => {
    const { toolCategories } = useData();
    const [toolData, setToolData] = useState({ name: '', url: '', description: '', categoryId: '' });

    useEffect(() => {
        if (isOpen) {
            if (toolToEdit) {
                setToolData(toolToEdit);
            } else {
                setToolData({ name: '', url: '', description: '', categoryId: toolCategories[0]?.id || '' });
            }
        }
    }, [toolToEdit, isOpen, toolCategories]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setToolData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (toolData.name && toolData.url && toolData.categoryId) {
            onSave(toolData);
            onClose();
        }
    };
    
    const categoryOptions = toolCategories.map(cat => ({ value: cat.id, label: cat.name }));
    const title = toolToEdit ? 'Editar Ferramenta' : 'Adicionar Nova Ferramenta';
    const footer = (
        <>
            <GlassButton onClick={onClose} variant="minimal">Cancelar</GlassButton>
            <GlassButton onClick={handleSubmit} className="!bg-indigo-500">Salvar</GlassButton>
        </>
    );

    return (
        <Modal isOpen={isOpen} onClose={onClose} title={title} footer={footer} maxWidth="max-w-lg">
            <form onSubmit={handleSubmit} className="space-y-4">
                <InputField
                    label="URL da Ferramenta"
                    name="url"
                    type="url"
                    value={toolData.url}
                    onChange={handleChange}
                    placeholder="https://exemplo.com"
                    required
                />
                <InputField
                    label="Nome da Ferramenta"
                    name="name"
                    value={toolData.name}
                    onChange={handleChange}
                    placeholder="Ex: Google Fonts"
                    required
                />
                <InputField
                    label="Descrição (opcional)"
                    name="description"
                    value={toolData.description}
                    onChange={handleChange}
                    placeholder="Para que serve esta ferramenta?"
                />
                 <CustomSelect
                    label="Categoria"
                    options={categoryOptions}
                    value={toolData.categoryId}
                    onChange={(e) => setToolData(prev => ({ ...prev, categoryId: e.target.value }))}
                />
            </form>
        </Modal>
    );
};

export default ToolFormModal;